import { Grid, Divider } from "@mui/material";


function CustomDivider() {
    return (
        <Grid container xs={12} style={{
            color: "#D3D3D3",
            backgroundColor: "#D3D3D3",
            border: "1px solid #D3D3D3",
            marginTop: '0.6%'
        }}>
            {/* <hr
                style={{
                    color: "#D3D3D3",
                    backgroundColor: "#D3D3D3",
                    border: "1px solid #D3D3D3",
                    marginTop: '1%'
                }}
            /> */}

        </Grid>
    );
}

export default CustomDivider;
